




















































import { computed, defineComponent, watch } from "@vue/composition-api";
import useContacts from "@/store/useContacts";
import useContact from "@/store/useContact";
import ContactViewModel from "@/models/ContactViewModel";
import { app } from "@/store/index";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./Sensors/SensorHeader.vue"),
    },
    setup() {
        const { contacts, getContacts } = useContacts();
        const { update } = useContact();

        const toggleActive = (contact: ContactViewModel) => {
            // at this point, contact.active has already been set by v-model
            console.log("Switch is now:", contact.active);

            update(contact)
                .then(() => getContacts())
                .catch(err => {
                    console.error("Update failed:", err);
                    // optional: rollback UI if update failed
                    contact.active = !contact.active;
                });
        };

        return {
            contacts,
            toggleActive,
        };
    },
});
